export default {
  BusinessReport: 'Business Report',
  Tips: 'You can select a time period as needed to generate a report. Business reports involve a large amount of data, and packaging is expected to take 1-3 minutes. After completion, you can directly view or download them online.',
  ExportReport: 'Export Report',
  Type: 'Type',
  ReportTime: 'Report Time',
  ApplicationExportTime: 'Application Export Time',
  FileSize: 'File Size',
  Status: 'Status',
  Options: 'Options',
  View: 'View',
  Download: 'Download',
  Delete: 'Delete',
  Cancel: 'Cancel',
  CancelTask: 'Are you sure to cancel the current export task?',
  CancelTaskContent: 'After cancellation, it cannot be restored. If necessary, it can be exported again',
  DeleteReport: 'Are you sure to delete the current report?',
  DeleteReportContent: 'After deletion, it cannot be restored. If necessary, it can be exported again',
}